/* eslint-disable */
import Component from 'gia/Component'

export default class CreateLists extends Component {
  constructor(element) {
    super(element)
  }

  lists() {
    const listToggle = $('.new-list-toggle')
    const listBox = $('#list-creator')
    const listCreate = $('.form-create-list__btn')
    const listClose = $('.close-creator')

    listToggle.click(function(e) {
      e.preventDefault()
      listBox.fadeToggle()
      $('#listName').focus()
    })

    listClose.click(function(e) {
      e.preventDefault()
      listBox.fadeToggle()
    })

    listCreate.click(function(e) {
      e.preventDefault()
      const listName = $('input#listName')

      if (listName.val().length > 0) {
        $.ajax({
          url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
          type: 'POST',
          data: {
            action: 'new_list',
            item: listName.val(),
          },
          beforeSend: function() {
            // $('ul.my-lists').css('opacity', '0.2');
          },
          success: function(result) {
            // $('ul.my-lists').html(result)
            window.location.replace(window.location.origin + '/lists')
            // listBox.fadeToggle()
            // listName.val('')
            // $('ul.my-lists').css('opacity', '1');
          },
        })
      } else {
        listName.after('<p class="error">Add the name of your new list</p>')
      }
    })
  }

  mount() {
    this.lists()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/CreateList.js